invHdApp.controller('MainController',
    ['$scope', '$location', '$localStorage', '$rootScope', 'User', '$routeParams', '$timeout', '$window', '$filter', 'socket', 'Order', 'FileUploader', '$http', 'Worker', 'Customer', 'tourConfig', 'WizardHandler', 'AclService', 'Lightbox', 'Stock', 'StockStore', 'Dayend', 'Account', 'RouteList', 'ngAudio', '$translate', 'Supplier', 'Location',
        function ($scope, $location, $localStorage, $rootScope, User, $routeParams, $timeout, $window, $filter, socket, Order, FileUploader, $http, Worker, Customer, tourConfig, WizardHandler, AclService, Lightbox, Stock, StockStore, Dayend, Account, RouteList, ngAudio, $translate, Supplier, Location) {

            window.parent.document.body.style.zoom = 0.85;

            $rootScope.lang = 'tr';
            if (localStorage.getItem("lang")) {
                $translate.use(localStorage.getItem("lang"));
                $scope.mainLanguage = localStorage.getItem("lang");
                $rootScope.lang = localStorage.getItem("lang");
            } else {
                $translate.use('tr');
                $scope.mainLanguage = 'tr';
            }

            $scope.changeLanguage = function (lang) {
                localStorage.setItem("lang", lang)
                $translate.use(localStorage.getItem("lang"));
                $rootScope.lang = lang;
            };

            $rootScope.realOrder = false;

            var lastType;
            var notLoad = ['/'];
            $scope.beepSound = ngAudio.load("sounds/beep.mp3");

            $scope.optimizedWorkers = [];
            $scope.optimizedWorkersID = [];
            $scope.optimizationSpinner = false;
            $rootScope.message = {
                'status': false,
                'text': '',
                'type': 'error'
            };

            $rootScope.dateTypes = [
                // {
                //     'name' : $translate.instant('CREATED_AT_TYPE'),
                //     'key': 'created_at'
                // },
                {
                    'name': $translate.instant('CARGO_DATE_TYPE'),
                    'key': 'cargo_date'
                },
                {
                    'name': $translate.instant('COMPLETED_AT_TYPE'),
                    'key': 'completed_at'
                },
                {
                    'name': $translate.instant('LAST_LOG_DATE'),
                    'key': 'last_log_date'
                }
            ];

            $rootScope.locationTypes = [
                {
                    'name': 'Konumu Olanlar',
                    'key': 'yes'
                },
                {
                    'name': 'Konumu Olmayanlar',
                    'key': 'no'
                },
            ];

            $rootScope.workerTypes = [
                {
                    'name': 'Kuryede Olanlar',
                    'key': 'yes'
                },
                {
                    'name': 'Kuryede Olmayanlar',
                    'key': 'no'
                },
            ];

            $rootScope.supportStatuses = [
                {
                    'name': $translate.instant('RESOLVED'),
                    'id': 'resolved'
                },
                {
                    'name': $translate.instant('UNRESOLVED'),
                    'id': 'unresolved'
                }
            ];

            $rootScope.permissions = [
                {
                    'name': $translate.instant('DELETE_ORDER_PERMISSION'),
                    'key': 'delete_order'
                },
                {
                    'name': $translate.instant('SHOW_ROUTE_PERMISSION'),
                    'key': 'show_route'
                },
                {
                    'name': $translate.instant('SHOW_CUSTOMER_PERMISSION'),
                    'key': 'show_customer'
                },
                {
                    'name': $translate.instant('SHOW_ORDER_PERMISSION'),
                    'key': 'show_order'
                },
                {
                    'name': $translate.instant('ADD_USER_PERMISSION'),
                    'key': 'add_user'
                },
                {
                    'name': $translate.instant('SHOW_FINANCE_PERMISSION'),
                    'key': 'show_finance'
                },
                {
                    'name': $translate.instant('SHOW_SETTING_PERMISSION'),
                    'key': 'show_setting'
                },
                {
                    'name': $translate.instant('EXCEL_PERMISSION'),
                    'key': 'excel_permission'
                },
                {
                    'name': $translate.instant('CREATE_ORDER_PERMISSION'),
                    'key': 'create_order_permission'
                },
                {
                    'name': $translate.instant('CREATE_PRODUCT_PERMISSION'),
                    'key': 'create_product_permission'
                },
                {
                    'name': $translate.instant('COMPLETE_ROUTE_PERMISSION'),
                    'key': 'complete_route_permission'
                },
                {
                    'name': $translate.instant('DELETE_ROUTE_PERMISSION'),
                    'key': 'delete_route_permission'
                },
                {
                    'name': $translate.instant('ADD_WORKER_PERMISSION'),
                    'key': 'add_worker_permission'
                },
                {
                    'name': $translate.instant('ADD_CUSTOMER_PERMISSION'),
                    'key': 'add_customer_permission'
                }
            ];

            $scope.paymentTypes = [
                {
                    name: $translate.instant('DEBT'),
                    id: 0
                },
                {
                    name: $translate.instant('CREDIT'),
                    id: 1
                }
            ];

            $scope.orderPaymentTypes = [
                {
                    name: $translate.instant('ONLINE_PAYMENT_ORDER'),
                    value: 'online'
                },
                {
                    name: $translate.instant('OFFLINE_PAYMENT_ORDER'),
                    value: 'offline'
                }
            ];

            $scope.filterTicketStatus = [
                {
                    name: 'Açık',
                    value: 'new'
                },
                {
                    name: 'Kapandı',
                    value: 'closed'
                }
            ];

            $scope.filterTicketCategory = [
                {
                    name: 'Sipariş & Teslimat Durumu',
                    value: 'order'
                },
                {
                    name: 'Teknik Problem',
                    value: 'technical'
                },
                {
                    name: 'Diğer',
                    value: 'other'
                }
            ];

            $scope.pageSizes = [
                25,
                50,
                100
            ];

            var customerAuthRoutes = [
                'customer-new-order',
                'customer-new-order',
                'customer-orders',
                'live-chat',
                'customer-map',
                'customer-routes',
                'customer-dashboard',
                'customer-account',
                'customer-settings',
                'customer-password',
                'customer-tracking',
                'customer-accounting',
                'customer-billing',
                'customer-feedback',
                'customer-check-orders',
                'customer-notifications',
                'satin-al',
            ];
            var guest = ['/login', '/register', '/forgot', '/sifre-sifirla'];
            $scope.pageViewLogin = guest.indexOf($location.path()) > -1 ? true : false;

            $rootScope.$on('loading:progress', function () {
                if (notLoad.indexOf(window.location.pathname) == -1) {
                    $scope.loadingEffect = true;
                }
            });

            $rootScope.$on('loading:finish', function () {
                if (notLoad.indexOf(window.location.pathname) == -1) {
                    $scope.loadingEffect = false;
                }
            });

            $scope.$on('$routeChangeStart', function ($event, next, current) {
                if (typeof $scope.authenticatedUser != 'undefined' && $scope.authenticatedUser.role == 3) {
                    var path = $location.url().split("/")[1];
                    if (customerAuthRoutes.indexOf(path.split("?")[0]) == -1) {
                        $location.path("/customer-orders");
                        return;
                    }
                }
            });

            $scope.newOrderData = {
                type: 1,
                exit_station_id: null,
                address: {},
                images: [],
                assign: 'manual',
                tracking_sms: 0,
                notifications: [{
                    type: 'push',
                    time: 30,
                    period: 'minute'
                }],
                faults: [{
                    stock: '',
                    description: ''
                }],
                checklists: [],
                scheduled_time: moment().add(1, 'hours').startOf('hour').format('DD/MM/YYYY hh:mm')
            };


            var ranges = {};
            ranges[$translate.instant("TODAY")] = [moment(), moment()];
            ranges[$translate.instant("YESTERDAY")] = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
            ranges[$translate.instant("LAST_7_DAYS")] = [moment().subtract(6, 'days'), moment()];
            ranges[$translate.instant("LAST_30_DAYS")] = [moment().subtract(29, 'days'), moment()];
            ranges[$translate.instant("THIS_MONTH")] = [moment().startOf('month'), moment().endOf('month')];
            ranges[$translate.instant("LAST_MONTH")] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];

            $scope.opts = {
                autoApply: false,
                locale: {
                    "format": "DD/MM/YYYY",
                    "separator": " - ",
                    "applyLabel": "Uygula",
                    "cancelLabel": "Vazgeç",
                    "fromLabel": "Dan",
                    "toLabel": "a",
                    "customRangeLabel": "Seç",
                    "daysOfWeek": [
                        "Pz",
                        "Pt",
                        "Sl",
                        "Çr",
                        "Pr",
                        "Cm",
                        "Ct"
                    ],
                    "monthNames": [
                        "Ocak",
                        "Şubat",
                        "Mart",
                        "Nisan",
                        "Mayıs",
                        "Haziran",
                        "Temmuz",
                        "Ağustos",
                        "Eylül",
                        "Ekim",
                        "Kasım",
                        "Aralık"
                    ],
                    "firstDay": 1
                },
                ranges: ranges
            }

            $scope.showStatus = function (status) {
                var selected = $filter('filter')($scope.statuses, { value: status });
                return (status && selected.length) ? selected[0].text : 'Not set';
            };

            $rootScope.menuStatus = false;
            $rootScope.hoverStatus = false;
            $scope.toggleMenu = function () {
                $rootScope.menuStatus = !$rootScope.menuStatus
            };
            $scope.hoverIn = function () {
                console.log('hover in')
                $rootScope.hoverStatus = true;
            };
            $scope.hoverOut = function () {
                console.log('hover out')
                $rootScope.hoverStatus = false;
            };

            var componentForm = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                administrative_area_level_2: 'short_name',
                country: 'long_name',
                postal_code: 'short_name'
            };

            var mapping = {
                street_number: 'number',
                route: 'street',
                locality: 'state',
                administrative_area_level_1: 'city',
                administrative_area_level_2: 'district',
                country: 'country',
                postal_code: 'zip'
            };

            $scope.colorList = [
                '#FF9800',
                '#3F51B5',
                '#2196F3',
                '#673AB7',
                '#009688',
                '#795548',
                '#607D8B',
                '#F44336'
            ];

            $rootScope.states = [];

            $scope.translate = function (key) {
                return $translate(key);
                return $translate(key).then(function (headline) {
                    console.log(headline)
                    return headline;
                }, function (translationId) {
                    // $scope.headline = translationId;
                });
            };

            $scope.statuses = [
                {
                    name: $translate.instant('OPEN'),
                    value: '',
                    id: 0,
                },
                {
                    name: $translate.instant('PAID_SUCCESS'),
                    value: 'complete',
                    id: 1,
                }
            ]

            $scope.$on('IdleStart', function () {
                if ($scope.authenticatedUser.setting.idle) {
                    // $('#idle').modal({
                    //     backdrop: 'static',
                    //     keyboard: false,
                    //     show: true
                    // });
                } else {
                    location.reload();
                }
            });

            $scope.refreshPage = function () {
                location.reload();
            }

            $scope.searchCustomer = function ($select, type) {
                if (type != lastType) $scope.searchRes = [];
                if ($select.search) {
                    return $http.get('api/find-customer', {
                        params: {
                            s: $select.search,
                            type: type
                        },
                        ignoreLoadingBar: true
                    }).then(function (response) {
                        $scope.searchRes = response.data.customers;
                    });
                    lastType = type;
                };
            };

            // Initialize filterCustomers if not already defined
            if (typeof $rootScope.filterCustomers === 'undefined') {
                $rootScope.filterCustomers = [];
            }
            
            $scope.getCustomers = function () {
                // $rootScope.filterCustomers'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterCustomers === 'undefined') {
                    $rootScope.filterCustomers = [];
                }
                
                $http.get('api/filter/customers', {
                    ignoreLoadingBar: true
                }).then(function (filterResponse) {
                    let uniqueCustomers = {};
                    
                if (filterResponse.data && filterResponse.data.customers) {
                    // customers zaten bir array, Object.values() kullanmaya gerek yok
                    filterResponse.data.customers.forEach(function(customer) {
                        if (customer.id) {
                            uniqueCustomers[customer.id] = customer;
                        }
                    });
                }

                    $http.get('api/dashboard', {
                        ignoreLoadingBar: true
                    }).then(function (response) {
                        if (response.data && response.data.orders && response.data.orders.data) {
                            response.data.orders.data.forEach(function(order) {
                                if (order.customer) {
                                    uniqueCustomers[order.customer.id] = order.customer;
                                }
                            });
                        }
                        
                        $rootScope.filterCustomers = Object.values(uniqueCustomers).sort((a,b) => 
                            (a.customer_name || a.dba_name).localeCompare(b.customer_name || b.dba_name)
                        );

                        $('.selectpicker').selectpicker('refresh');
                    }).catch(function(error) {
                        console.error('Dashboard API error:', error);
                        $rootScope.filterCustomers = [];
                    });
                }).catch(function(error) {
                    console.error('Filter customers API error:', error);
                    $rootScope.filterCustomers = [];
                });
            };

            // Initialize filterCompanies if not already defined
            if (typeof $rootScope.filterCompanies === 'undefined') {
                $rootScope.filterCompanies = [];
            }
            
            $scope.getCompanies = function () {
                // $rootScope.filterCompanies'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterCompanies === 'undefined') {
                    $rootScope.filterCompanies = [];
                }
                
                // Her zaman taze veri çek - eski cache kontrolü kaldırıldı
                $http.get('api/filter/companies', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterCompanies = response.data.companies;
                }).catch(function(error) {
                    console.error('Filter companies API error:', error);
                    $rootScope.filterCompanies = [];
                });
            };

            // Initialize filterRoutes if not already defined
            if (typeof $rootScope.filterRoutes === 'undefined') {
                $rootScope.filterRoutes = [];
            }
            
            $scope.getRoutes = function () {
                // $rootScope.filterRoutes'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterRoutes === 'undefined') {
                    $rootScope.filterRoutes = [];
                }
                
                // Her zaman taze veri çek - eski cache kontrolü kaldırıldı
                $http.get('api/filter/routes', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterRoutes = response.data.routes;
                }).catch(function(error) {
                    console.error('Filter routes API error:', error);
                    $rootScope.filterRoutes = [];
                });
            };

            // Initialize filterWorkers if not already defined
            if (typeof $rootScope.filterWorkers === 'undefined') {
                $rootScope.filterWorkers = [];
            }
            
            $scope.getWorkers = function () {
                // $rootScope.filterWorkers'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterWorkers === 'undefined') {
                    $rootScope.filterWorkers = [];
                }
                
                // Her zaman taze veri çek - eski cache kontrolü kaldırıldı
                $http.get('api/filter/workers', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterWorkers = response.data.workers;
                }).catch(function(error) {
                    console.error('Filter workers API error:', error);
                    $rootScope.filterWorkers = [];
                });
            };

            // Initialize filterPlates if not already defined
            if (typeof $rootScope.filterPlates === 'undefined') {
                $rootScope.filterPlates = [];
            }
            
            $scope.getPlates = function () {
                // $rootScope.filterPlates'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterPlates === 'undefined') {
                    $rootScope.filterPlates = [];
                }
                
                $http.get('api/filter/plates', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterPlates = response.data.plates;
                }).catch(function(error) {
                    console.error('Filter plates API error:', error);
                    $rootScope.filterPlates = [];
                });
            };

            // Initialize filterStations if not already defined
            if (typeof $rootScope.filterStations === 'undefined') {
                $rootScope.filterStations = [];
            }
            
            $scope.getStations = function () {
                // $rootScope.filterStations'ı güvenli bir şekilde tanımla
                if (typeof $rootScope.filterStations === 'undefined') {
                    $rootScope.filterStations = [];
                }
                
                $http.get('api/filter/stations', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterStations = response.data.stations;
                }).catch(function(error) {
                    console.error('Filter stations API error:', error);
                    $rootScope.filterStations = [];
                });
            };

            $scope.calculateTVS = function (order) {
                return order.tvs.date_str
            }

            $rootScope.filterSupportTypes = [];
            $scope.getSupportTypes = function () {
                $http.get('api/filter/support-types', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterSupportTypes = response.data.support_types;
                });
            };

            $rootScope.filterCities = [];
            $scope.getCities = function () {
                $http.get('api/filter/cities', {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterCities = response.data.cities;
                });
            };

            $rootScope.filterDistricts = [];
            $scope.getDistricts = function (city) {
                $rootScope.filterDistricts = [];
                city.forEach(element => {
                    var find = $rootScope.filterCities.findIndex(function (item) {
                        return element == item.name;
                    })
                    if (find > -1) {
                        $rootScope.filterDistricts = [...$rootScope.filterDistricts, ...$rootScope.filterCities[find].districts];
                    }
                });
                setTimeout(() => {
                    $('.selectpicker').selectpicker('refresh');
                }, 400);
            };

            $rootScope.filterNeigbourdhood = [];
            $scope.getNeighbourdhood = function (district, city) {
                $http.get('api/filter/neighbourdhoods?district=' + district + '&city=' + city, {
                    ignoreLoadingBar: true
                }).then(function (response) {
                    $rootScope.filterNeigbourdhood = response.data;
                    $('.selectpicker').selectpicker('refresh');
                });
            };

            $rootScope.changeSupportType = function (support_type_id, order_id) {
                $http.post('api/change-supports', { order_id: order_id, support_type_id: support_type_id }).then(function (response) {
                    $scope.$broadcast('update_support', response);
                });
            };

            $rootScope.changeSupportStatus = function (status, order_id) {
                $http.post('api/change-support-status', { order_id: order_id, status: status }).then(function (response) {
                    $scope.$broadcast('update_support', response);
                });
            };

            $scope.createWebhook = function () {
                Account.createWebhook({ customer_id: $scope.customer.id }).success(function (data, status, headers, config) {
                    Messenger().post(data.message);
                    console.log(data);
                    $scope.customer.user.webhook = data.token.access_token;
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                })
            };

            function removeURLParameters(url, parameters) {
                parameters.forEach(function (element) {
                    url = url
                        .replace(new RegExp('[?&]' + element + '=[^&#]*(#.*)?$'), '$1')
                        .replace(new RegExp('([?&])' + element + '=[^&]*&'), '$1');
                });
                return url;
            }


            $scope.init = function (user) {
                User.getUser().success(function (data, status, headers, config) {
                    AclService.flushStorage();
                    var abilities = {
                        user: []
                    };
                    AclService.setAbilities(abilities);
                    AclService.attachRole('user');
                    $scope.can = AclService.can;

                    $scope.authenticatedUser = data;
                    if (typeof $scope.authenticatedUser != 'undefined' && $scope.authenticatedUser.role == 3) {
                        var path = $location.url().split("/")[1];
                        if (customerAuthRoutes.indexOf(removeURLParameters(path, ['data', 'real_order', 'route_id', 'order_id'])) == -1) {
                            $location.path("/customer-orders");
                            return;
                        }
                    }

                    if (data.authorization.maps) AclService.addAbility('user', 'maps');
                    if (data.authorization.office) AclService.addAbility('user', 'office');
                    if (data.authorization.customers) AclService.addAbility('user', 'customers');
                    if (data.authorization.users) AclService.addAbility('user', 'users');
                    if (data.authorization.settings) AclService.addAbility('user', 'settings');
                    if (data.authorization.reports) AclService.addAbility('user', 'reports');
                    if (data.role == 3) {
                        AclService.addAbility('user', 'customer')
                    };
                    $rootScope.selectedTeamName = data.teams[0];
                    $rootScope.firstLoad = true;

                    if (data.tour != -1 && $scope.authenticatedUser.remaining_day > 0) {
                        // WizardHandler.wizard().goTo(data.tour);
                        $('#tutorialModal').modal('show');
                        $scope.$on('wizard:stepChanged', function (event, args) {
                            Order.tour({ step: args.index });
                        });
                    }

                    if (data.update_status) {
                        $scope.update_data = data.update;
                        $('#updates').modal({
                            backdrop: 'static',
                            keyboard: false,
                            show: true
                        });
                    }

                    Account.districts({ city_id: 34 }).success(function (data, status, headers, config) {
                        $rootScope.states = data.data
                    })

                    /* Tawk_API.visitor = {
                        name  : $scope.authenticatedUser.company_name
                    }; */
                });
            };

            function changeFavicon(src) {
                var link = document.createElement('link'),
                    oldLink = document.getElementById('dynamic-favicon');
                link.id = 'dynamic-favicon';
                link.rel = 'shortcut icon';
                link.href = src;
                if (oldLink) {
                    document.head.removeChild(oldLink);
                }
                document.head.appendChild(link);
            }

            $scope.firstLook = function () {
                User.firstLook({ step: 2 }).success(function (data, status, headers, config) {
                    $('#firstLook').modal('hide');
                });
            }

            $scope.updates = function () {
                User.updates().success(function (data, status, headers, config) {
                    $('#updates').modal('hide');
                });
            }

            $scope.mainPage = function () {
                if ($scope.authenticatedUser.customer_id) {
                    setTimeout(function () {
                        $location.path('customer-orders');
                        $scope.$apply();
                    }, 300);
                } else {
                    setTimeout(function () {
                        $location.path('orders');
                        $scope.$apply();
                    }, 300);
                }
                /*
                User.getUser().success(function(data, status, headers, config) {
                    if(data.authorization.maps) $location.path('').search('type', null);  
                    else if(data.authorization.office) $location.path('projeler').search('type', null);
                    else if(data.authorization.users) $location.path('calisan-yonetimi').search('type', null);
                    else if(data.authorization.customers) $location.path('musteri-yonetimi').search('type', null);  
                    else if(data.authorization.reports) $location.path('order-report').search('type', null);
                    else if(data.authorization.settings) $location.path('profile').search('type', null);
                });
                */
            }

            $scope.newWorkerLink = function () {
                $('#newOrder').modal('hide');
                setTimeout(function () {
                    $location.path('yeni-calisan');
                    $scope.$apply();
                }, 300);
            }

            $scope.selectedTeam = function (team) {
                $rootScope.selectedTeamName = team;
                $scope.$broadcast('teamChange', team);
            }

            socket.on('worker_answer', function (data) {
                $scope.$broadcast('worker_answer', data);
            });

            socket.on('location_update', function (data) {
                $scope.$broadcast('location_update', data);
            });

            socket.on('delete_order', function (data) {
                $scope.$broadcast('delete_order', data);
            });

            socket.on('refresh_page', function (data) {
                window.location.reload();
            });

            socket.on('new_order', function (data) {
                $scope.$broadcast('new_order', data);
            });

            socket.on('update_order', function (data) {
                $scope.$broadcast('update_order', data);
            });

            socket.on('worker_status', function (data) {
                $scope.$broadcast('worker_status', data);
            });
            $rootScope.messageCount = 0;
            socket.on('new_message', function (data) {
                $scope.beepSound.play();
                $rootScope.messageCount += 1;
                $scope.$broadcast('new_message', data);
            });

            $scope.addOrderNotification = function () {
                if (typeof $scope.newOrderData.notifications === 'undefined') {
                    $scope.newOrderData.notifications = [];
                }
                $scope.newOrderData.notifications.push({
                    type: 'push',
                    time: 30,
                    period: 'minute'
                });
            }

            $scope.removeOrderNotification = function (index) {
                $scope.newOrderData.notifications.splice(index, 1);
            }

            $scope.newTaskModal = function (_callback) {
                Order.newOrderData().success(function (data) {
                    $scope.orderData = data;
                    $scope.newOrderData = {
                        type: 1,
                        address: {},
                        exit_station_id: null,
                        images: [],
                        assign: 'manual',
                        tracking_sms: 0,
                        notifications: [{
                            type: 'push',
                            time: 30,
                            period: 'minute'
                        }],
                        faults: [{
                            stock: '',
                            description: ''
                        }],
                        checklists: [],
                        scheduled_time: moment().add(15 - (moment().format('mm') % 15), 'minutes').startOf('minute').format('DD/MM/YYYY hh:mm')
                    };
                    $('.new-work-screen').scrollTop(0);
                    // Create Map
                    createMap();
                    $scope.addOrderLocation();
                    jQuery.datetimepicker.setLocale('en');
                    jQuery('#datetimepicker').datetimepicker({
                        mask: true,
                        format: 'd/m/Y H:i',
                        defaultDate: $scope.newOrderData.scheduled_time,
                        inline: true,
                        timepickerScrollbar: false,
                        allowTimes: [
                            "00:00", "00:15", "00:30", "00:45",
                            "01:00", "01:15", "01:30", "01:45",
                            "02:00", "02:15", "02:30", "02:45",
                            "03:00", "03:15", "03:30", "03:45",
                            "04:00", "04:15", "04:30", "04:45",
                            "05:00", "05:15", "05:30", "05:45",
                            "06:00", "06:15", "06:30", "06:45",
                            "07:00", "07:15", "07:30", "07:45",
                            "08:00", "08:15", "08:30", "08:45",
                            "09:00", "09:15", "09:30", "09:45",
                            "10:00", "10:15", "10:30", "10:45",
                            "11:00", "11:15", "11:30", "11:45",
                            "12:00", "12:15", "12:30", "12:45",
                            "13:00", "13:15", "13:30", "13:45",
                            "14:00", "14:15", "14:30", "14:45",
                            "15:00", "15:15", "15:30", "15:45",
                            "16:00", "16:15", "16:30", "16:45",
                            "17:00", "17:15", "17:30", "17:45",
                            "18:00", "18:15", "18:30", "18:45",
                            "19:00", "19:15", "19:30", "19:45",
                            "20:00", "20:15", "20:30", "20:45",
                            "21:00", "21:15", "21:30", "21:45",
                            "22:00", "22:15", "22:30", "22:45",
                            "23:00", "23:15", "23:30", "23:45"
                        ],
                        scrollMonth: false,
                        onChangeDateTime: function (dp, $input) {
                            $scope.newOrderData.scheduled_time = moment($input.val(), 'DD/MM/YYYY hh:mm').format('DD/MM/YYYY hh:mm');
                        }
                    })
                        .datetimepicker('reset');
                    if (typeof _callback !== 'undefined') _callback(data);
                });
            }

            $scope.loadRoute = function () {
                $('#routeDetail').modal('show');
                $scope.routeMarkers = [];
                Order.loadRoute($scope.selectedWork.id).success(function (data) {

                    var location = new google.maps.LatLng(Number($scope.selectedWork.customer.latitude), Number($scope.selectedWork.customer.longitude)),
                        bounds = new google.maps.LatLngBounds(),
                        route = [],
                        workerPath;

                    $scope.historyMap = new google.maps.Map(document.getElementById('map-history'), {
                        zoom: 13,
                        center: location,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    });

                    data.locations.forEach(function (element) {
                        var routeLocation = new google.maps.LatLng(Number(element.latitude), Number(element.longitude));
                        route.push(routeLocation);
                        var marker = new google.maps.Marker({
                            position: routeLocation,
                            map: $scope.historyMap
                        });
                        var infowindow = new google.maps.InfoWindow({
                            content: "<strong>Doğruluk : </strong> " + element.accuracy + ' Metre </br> <strong>Tarih : </strong>' + moment(element.created_at).format('DD/MM/YYYY hh:mm')
                        });
                        marker.addListener('click', function () {
                            infowindow.open($scope.historyMap, marker);
                        });
                        bounds.extend(routeLocation);
                        $scope.routeMarkers.push(marker);
                    });
                    var iconsetngs = {
                        path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
                    };

                    workerPath = new google.maps.Polyline({
                        path: route,
                        geodesic: true,
                        strokeColor: '#024466',
                        strokeOpacity: 0.7,
                        strokeWeight: 2,
                        icons: [{
                            repeat: '140px', //CHANGE THIS VALUE TO CHANGE THE DISTANCE BETWEEN ARROWS
                            icon: iconsetngs,
                            offset: '100%'
                        }]
                    });
                    workerPath.setMap($scope.historyMap);
                    $scope.historyMap.fitBounds(bounds);

                    // Company Marker
                    if ($scope.selectedWork.customer.latitude.length > 0) {
                        var routeLocation = new google.maps.LatLng(Number($scope.selectedWork.customer.latitude), Number($scope.selectedWork.customer.longitude));
                        var marker = new google.maps.Marker({
                            position: routeLocation,
                            map: $scope.historyMap,
                            icon: 'img/markers/location_guest.png'
                        });
                        var infowindow = new google.maps.InfoWindow({
                            content: "<strong>Firma Adı : </strong> " + $scope.selectedWork.customer.customer_name + '</br> <strong>Adres : </strong>' + $scope.selectedWork.customer.customer_name
                        });
                        marker.addListener('click', function () {
                            infowindow.open($scope.historyMap, marker);
                        });
                        infowindow.open($scope.historyMap, marker);
                        bounds.extend(routeLocation);
                        $scope.historyMap.fitBounds(bounds);
                    }
                });
            }

            $scope.toggleMarkerVisible = function () {
                $scope.routeMarkers.forEach(function (element) {
                    if (element.getVisible()) {
                        element.setVisible(false);
                    }
                    else {
                        element.setVisible(true);
                    }
                });
                $scope.routeMarkerVisible = !$scope.routeMarkerVisible;
            }

            $scope.duplicateWork = function () {
                if (confirm('Bu iş tüm bilgileri ile oluşturuldu durumunda kopyalanacaktır. Devam etmek istiyor musunuz?')) {
                    Order.duplicateWork($rootScope.selectedWork).success(function (data, status, headers, config) {
                        $scope.getOrderDetails(data);
                        Messenger().post({ message: 'İş Başarıyla Kopyalandı', type: "success" });
                    })
                        .error(function (data) {
                            Messenger().post({ message: data.message, type: "error" });
                        });
                }
                return;
                $scope.newTaskModal(function (data) {
                    $scope.newOrderData = $rootScope.selectedWork;
                    $scope.newOrderData.address = $rootScope.selectedWork.customer;
                    $scope.addressSelected($scope.newOrderData.address, 'outsource');
                    delete $scope.newOrderData.id;
                    $scope.newOrderData.worker_id = [$scope.newOrderData.worker_id];
                });
            }

            $scope.updateWork = function (type) {
                if (type && type == 'customer') {
                    $location.path('customer-new-order').search('order_id', $rootScope.selectedWork.id);
                } else {
                    $location.path('new-order').search('order_id', $rootScope.selectedWork.id);
                }
            }

            // $scope.printOrder = function(id) {
            //     window.open('/print-order/'+id,'popUpWindow','height=300,width=445,left=100,top=100,resizable=no,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes');
            // }

            $scope.printOrder = function (id) {
                window.open('/print-order?order_id=' + id, '_blank');
                return false;

                var newwindow = window.open('/print-order/?order_id=' + id, 'Print Order', 'width=700, height=470');
                if (window.focus) {
                    newwindow.focus()
                }
                return false;
            }

            $scope.printOrderPdf = function (ids) {
                var url;
                if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 51) {
                    url = '/print-new-barcode/' + ids;
                } else if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 87) {
                    url = '/print-fast-barcode-order/' + ids;
                } else {
                    url = '/print-pdf-order/' + ids;
                }
                var newwindow = window.open(url, 'Print Order', 'width=700, height=470');
                if (window.focus) newwindow.focus();
                return false;
            }

            $scope.sendOrdersToMove = function (ids) {
                $location.url('/order-move?ids=' + ids);
                // $location.path('order-move').search('ids', ids);
            }

            $scope.printPdfOrder = function (id, index = null) {
                var url, base = '/print-pdf-order/' + id;
                if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 51) {
                    base = '/print-new-barcode/' + id;
                } else if ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 87) {
                    base = '/print-fast-barcode-order/' + id;
                }
                url = index !== null ? base + '?index=' + index : base;
                var newwindow = window.open(url, 'Print Order', 'width=700, height=470');
                if (window.focus) newwindow.focus();
                return false;
            }

            // Yeni optimize edilmiş barkod yazdırma
            $scope.printFastBarcodeOrder = function (id, index = null) {
                var clickTime = performance.now();
                console.log('🖱️ Barkod butonu tıklandı:', new Date().toLocaleTimeString());
                
                var newwindow = window.open('/print-fast-barcode-order/' + id + '?index=' + index, 'Print Order', 'width=700, height=470');
                
                var openTime = performance.now();
                console.log('⏱️ window.open() süresi:', Math.round(openTime - clickTime) + 'ms');
                
                if (window.focus) {
                    newwindow.focus()
                }
                
                // Popup açılma zamanını logla
                if (newwindow) {
                    console.log('✅ Popup açıldı, sayfa yükleniyor...');
                } else {
                    console.error('❌ Popup BLOKE EDİLDİ! Popup blocker kapalı olmalı.');
                }
                
                return false;
            }

            $scope.printWorker = function (id) {
                var newwindow = window.open('/print-worker/' + id, 'Print Worker', 'width=700, height=470');
                if (window.focus) {
                    newwindow.focus()
                }
                return false;
            }

            $scope.openOptimize = function () {
                if ($scope.selectedRouteOrder.length == 0) {
                    alert('Lütfen rotalama yapmak istediğiniz işleri seçiniz.');
                    return true;
                }
                $scope.optimize = {
                    optimizeBy: 1
                };
                $scope.optimize.workers = [];
                Order.getWorkersForOptimizing().success(function (data, status, headers, config) {
                    $scope.optimizedWorkers = data;
                    for (var i = 0; i < data.length; i++) {
                        $scope.optimize.workers.push(data[i]['id']);
                    }
                    $('#optimizeRoute').modal('show');
                })
                    .error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    });
            }


            $scope.optimizeStep = false;
            $scope.selectedRouteOrder = [];
            $scope.addSelectedOrderForOptimization = function (item) {
                if ($scope.selectedRouteOrder.indexOf(item) > -1) {
                    $scope.selectedRouteOrder.splice($scope.selectedRouteOrder.indexOf(item), 1);
                } else {
                    $scope.selectedRouteOrder.push(item);
                }
            }

            $scope.getCheckbox = function (value) {
                try {
                    return JSON.parse(value);
                } catch (error) {
                    return [];
                }
            }

            $scope.newOrder = function (newWork) {
                // if(newWork) {
                /* if($scope.newOrderData.assign == 'manual' && typeof $scope.newOrderData.worker_id == 'undefined') {
                    $scope.info = {
                        title : "Dikkat",
                        message : "Manuel iş atamalarında personel seçmeniz gerekmektedir.",
                        class : 'danger'
                    };
                    $('#orderInfo').modal('show');
                }else { */
                Order.newOrder($scope.newOrderData).success(function (data, status, headers, config) {
                    $('#newOrder').modal('hide');
                    $scope.$broadcast('new_order', data);
                    $scope.newOrderData = {
                        type: 1,
                        exit_station_id: null,
                        address: {},
                        images: [],
                        scheduled_time: moment().add(1, 'hours').startOf('hour').format('DD/MM/YYYY hh:mm')
                    };
                    if ($scope.orderFromTour) $('#tutorialModal').modal('show');
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                });
                /*    }
                 }else {
                    $scope.info = {
                        title : "Dikkat",
                        message : "Lütfen açıklama, müşteri, adres ve personel alanlarını doldurun.",
                        class : 'danger'
                    };
                    $('#orderInfo').modal('show');
                } */
            };

            $scope.assignWorker = function () {
                Order.assignWorker($rootScope.selectedWork).success(function (data, status, headers, config) {
                    $rootScope.selectedWork = data;
                    $scope.$broadcast('updateOrder', data);
                    Messenger().post({ message: 'Başarılı', type: "success" });
                    $('#assignWorker').modal('hide');
                });
            }

            $scope.changeWorkStatus = function () {
                Order.changeWorkStatus($rootScope.selectedWork).success(function (data, status, headers, config) {
                    $rootScope.selectedWork = data;
                    $scope.$broadcast('updateOrder', data);
                    Messenger().post({ message: 'Başarılı', type: "success" });
                    $('#changeWorkStatus').modal('hide');
                });
            }

            $scope.addressSelected = function (selected, type) {
                console.log(selected);
                if (typeof type === 'undefined') {
                    if (typeof selected !== 'undefined') {
                        var customer = selected.originalObject;
                    } else {
                        var customer = [];
                    }
                } else {
                    var customer = selected;
                }
                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    var location = new google.maps.LatLng(customer.latitude, customer.longitude);
                    if (typeof $scope.searchMap !== 'undefined') {
                        createMap();
                    }
                    setTimeout(function () {
                        $scope.searchMap.setCenter(location);
                        $scope.marker.setDuration(1000);
                        $scope.marker.setEasing("swing");
                        $scope.marker.setPosition(location);
                        angular.merge($scope.newOrderData.address, customer);
                        $scope.newOrderData.address.city = customer.state;
                        $scope.newOrderData.address.state = customer.city;
                        $scope.newOrderData.address.address = customer.address;
                        $scope.newOrderData.address.zipcode = customer.zipcode;
                        $rootScope.states.forEach(element => {
                            if (element.abbreviation == customer.city) {
                                $scope.newOrderData.address.state = element.name;
                                return true;
                            }
                        });
                        $scope.$apply();
                    }, 300);
                }

                if (typeof customer !== 'undefined' && typeof customer.fields_values !== 'undefined') {
                    $scope.newOrderData.address.fields = {};
                    angular.forEach(customer.fields_values, function (value, key) {
                        var val = value.value;
                        if (value.type == 'number') val = Number(value.value);
                        if (value.type == 'date') val = new Date(value.value);
                        $scope.newOrderData.address.fields[value.customer_field_id] = val;
                    });
                }
            }

            $scope.locationSelected = function (selected, type) {
                if (typeof type === 'undefined') {
                    if (typeof selected !== 'undefined') {
                        var customer = selected.originalObject;
                    } else {
                        var customer = [];
                    }
                } else {
                    var customer = selected;
                }
                if (typeof customer !== 'undefined' && typeof customer.latitude !== 'undefined') {
                    var location = new google.maps.LatLng(customer.latitude, customer.longitude);
                    setTimeout(function () {
                        $scope.searchMap.setCenter(location);
                        $scope.locationMarker.setDuration(1000);
                        $scope.locationMarker.setEasing("swing");
                        $scope.locationMarker.setPosition(location);
                        angular.merge($scope.newOrderData.location, customer);
                        $scope.newOrderData.location.city = customer.state;
                        $scope.newOrderData.location.state = customer.city;
                        $scope.newOrderData.location.address = customer.address;
                        $scope.newOrderData.location.zipcode = customer.zipcode;
                        $scope.$apply();
                    }, 300);
                }
            }

            $scope.addOrderLocation = function (data) {
                if (data) {
                    $scope.newOrderData.location = data;
                    var location = new google.maps.LatLng(Number(data.latitude), Number(data.longitude));
                } else {
                    $scope.newOrderData.location = {};
                    var location = new google.maps.LatLng(Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon));
                }
                var bounds = new google.maps.LatLngBounds();
                setTimeout(function () {
                    $scope.locationMarker = new SlidingMarker({
                        position: location,
                        map: $scope.searchMap,
                        visible: true,
                        draggable: true,
                        icon: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
                    });
                    $scope.locationMarker.addListener('dragend', function (event) {
                        var latlng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    var place = results[0];
                                    var details = place.geometry && place.geometry.location ? {
                                        latitude: place.geometry.location.lat(),
                                        longitude: place.geometry.location.lng()
                                    } : {};
                                    for (var i = 0; i < place.address_components.length; i++) {
                                        var addressType = place.address_components[i].types[0];
                                        if (componentForm[addressType]) {
                                            var val = place.address_components[i][componentForm[addressType]];
                                            details[mapping[addressType]] = val;
                                        }
                                    }
                                    details.formatted = place.formatted_address;
                                    details.placeId = place.place_id;
                                    details.address = place.formatted_address;
                                    angular.merge($scope.newOrderData.location, details);
                                    $scope.newOrderData.location.city = details.state;
                                    $scope.newOrderData.location.state = details.city;
                                    $scope.newOrderData.location.address = (details.number ? details.number : '') + ' ' + (details.street ? details.street : '');
                                    $scope.newOrderData.location.zipcode = details.zip;
                                    $rootScope.states.forEach(element => {
                                        if (element.abbreviation == details.city) {
                                            $scope.newOrderData.location.state = element.name;
                                            return true;
                                        }
                                    });
                                    $scope.$apply();
                                }
                            }
                        });
                    });
                }, 600);
            }

            $scope.removeOrderLocation = function () {
                $scope.locationMarker.setMap(null);
                delete $scope.newOrderData.location;
            }

            $scope.deleteWork = function () {
                Order.deleteWork($rootScope.selectedWork).success(function (data, status, headers, config) {
                    $rootScope.selectedWork = data;
                    $scope.$broadcast('deleteOrder', data);
                    $('#deleteWork').modal('hide');
                });
            }

            $scope.deleteTask = function () {
                Order.deleteTask($rootScope.selectedWork).success(function (data, status, headers, config) {
                    $rootScope.selectedWork = data;
                    $scope.$broadcast('deleteTask', data);
                    $('#deleteTask').modal('hide');
                });
            }

            $scope.getOrderDetails = function (work) {
                if(work.source == 'mobile' && work.images.length && (work.location == null || !work.location.name)) {
                    return $location.path('new-order').search('order_id', work.id);
                }
                $rootScope.selectedWork = null;
                $rootScope.loadingWork = true;
                var id = work.id;
                if (typeof id == 'undefined') {
                    var id = work;
                }
                Order.order(id).then(function (response) {
                    var data = response.data;
                    $rootScope.loadingWork = false;
                    $rootScope.selectedWork = data.order;
                    $scope.data = {
                        'steps': data.steps,
                        'workers': data.workers
                    }
                    $scope.data.steps.unshift({
                        id: 0,
                        name: 'Oluşturuldu'
                    });
                    $scope.addCallRecord = false;
                    if ($scope.selectedWork.items_code && Array.isArray($scope.selectedWork.items_code)) {
                        $scope.selectedWork.items_code.forEach(element => {
                        var typeNumber = 10;
                        var errorCorrectionLevel = 'L';
                        var qr = qrcode(typeNumber, errorCorrectionLevel);
                        qr.addData(element.code);
                        qr.make();
                        element.qr = qr.createDataURL(10);
                        });
                    }
                    $scope.supportTypeId = 0
                    $scope.supportStatus = null;

                    if (data.order.bovo_order_map) {
                        Order.getBovoOrder($scope.selectedWork.id).then(function (response) {
                            $rootScope.selectedWork.tracking_url = response.data.order.tracking_url;
                        });
                    }
                    if (data.order.pakettaxi_order_map) {
                        Order.getPakettaxiOrder($scope.selectedWork.id).success(function (data, status, headers, config) {
                            $rootScope.selectedWork.pakettaxiOrder = data.order;
                        });
                    }
                    if (data.order.nova_order_map) {
                        Order.getNovaOrder($scope.selectedWork.id).success(function (data, status, headers, config) {
                            $rootScope.selectedWork.novaOrder = data.order;
                        });
                    }
                    if (data.order.kolaygelsin_order_map) {
                        Order.getKolayGelsinOrder($scope.selectedWork.id).success(function (data, status, headers, config) {
                            $rootScope.selectedWork.kolaygelsinOrder = data.order;
                        });
                    }
                    if ($scope.selectedWork.support) {
                        $scope.supportTypeId = $scope.selectedWork.support.support_type_id
                        $scope.supportStatus = $scope.selectedWork.support.status
                    }
                    $('#orderDetail').modal('show');
                    setTimeout(() => {
                        $('#tabContent a[href="#details"]').tab('show');
                        $scope.$apply()
                    }, 50);
                }).catch(function(error) {
                    $rootScope.loadingWork = false;
                    console.error('Order detail error:', error);
                    alert('İş detayı yüklenirken bir hata oluştu. Lütfen tekrar deneyin.');
                });
            }

            $scope.changeVariable = function (a, b) {
                $scope[a] = b;
            }

            $scope.statusOrder = [
                { value: 'ring', text: 'Gönderici\'den Teslim Alındı' },
                { value: 'transfer', text: 'Transfer Merkezinde' },
                { value: 'station', text: 'Teslimat Şubesinde' },
                { value: 'last', text: 'Dağıtımda' },
                { value: ['complete', 'fail'], text: 'Tamamlandı / Tamamlanmadı' }
            ];

            // Status'a göre hangi adıma kadar aktif olacağını belirleme
            $scope.isStepActive = function (statusValue) {
                var currentStatus = 'created';
                if ($scope.selectedWork && $scope.selectedWork.status) {
                    currentStatus = $scope.selectedWork.status.value;
                }
                const currentStatusIndex = $scope.statusOrder.findIndex(status =>
                    Array.isArray(status.value)
                        ? status.value.includes(currentStatus)
                        : status.value === currentStatus
                );

                const stepIndex = $scope.statusOrder.findIndex(status =>
                    Array.isArray(status.value)
                        ? status.value.includes(statusValue)
                        : status.value === statusValue
                );

                if (currentStatus == 'created') {
                    return false;
                }

                return stepIndex <= currentStatusIndex;
            };

            // Son adımın icon ve text'ini belirleme
            $scope.getFinalStepInfo = function () {
                if (!$scope.selectedWork || !$scope.selectedWork.status) {
                    return {
                        icon: '/icon-complete.png',
                        text: 'Tamamlandı',
                        class: 'complete'
                    };
                }
                if ($scope.selectedWork.status.value === 'complete') {
                    return {
                        icon: '/icon-complete.png',
                        text: 'Tamamlandı',
                        class: 'complete'
                    };
                } else if ($scope.selectedWork.status.value === 'fail') {
                    return {
                        icon: '/icon-complete.png',
                        text: 'Tamamlanamadı',
                        class: 'fail'
                    };
                }
                return {
                    icon: '/icon-complete.png',
                    text: 'Tamamlandı / Tamamlanmadı',
                    class: ''
                };
            };

            $scope.getWorkerDetails = function (id) {
                $rootScope.loadingWork = true;
                Worker.show(id).success(function (data, status, headers, config) {
                    $scope.worker = data.worker;
                    $scope.teams = data.teams;
                    $rootScope.loadingWork = false;
                    $('#workerDetail').modal('show');
                });
            }

            $scope.chageDocumentField = function (key, id, value) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Worker.chageDocumentField({ worker_id: $scope.worker.id, id: id, key: key, value: value }).success(function (data, status, headers, config) {
                        $scope.getWorkerDetails($scope.worker.id);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.chageUserStatus = function (status) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Worker.chageUserStatus({ worker_id: $scope.worker.id, status: status }).success(function (data, status, headers, config) {
                        $scope.getWorkerDetails($scope.worker.id);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.changeSupplierStatus = function (status, data) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Supplier.changeSupplierStatus({ supplier: data, status: status }).success(function (data, status, headers, config) {
                        $scope.getSupplierDetail(data.id);
                        $scope.refreshData();
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.updateWorkerField = function (key, value) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Worker.updateWorkerField({ worker_id: $scope.worker.id, key: key, value: value }).success(function (data, status, headers, config) {
                        $scope.getWorkerDetails($scope.worker.id);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.chageWorkerStatus = function (status) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Worker.chageWorkerStatus({ worker_id: $scope.worker.id, status: status }).success(function (data, status, headers, config) {
                        $scope.getWorkerDetails($scope.worker.id);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.chageWorkerRouteStatus = function (status) {
                if (confirm('Bunu yapmak istediğinize emin misiniz ? ')) {
                    Worker.chageWorkerRouteStatus({ worker_id: $scope.worker.id, status: status }).success(function (data, status, headers, config) {
                        $scope.getWorkerDetails($scope.worker.id);
                    }).error(function (data) {
                        Messenger().post({ message: data.message, type: "error" });
                    })
                }
            };

            $scope.getCustomerDetails = function (id) {
                $rootScope.loadingWork = true;
                Customer.show(id).success(function (data, status, headers, config) {
                    $scope.customer = data.customer;
                    $scope.chart = data.chart;
                    $scope.fields = data.fields;
                    $scope.workTypes = data.workTypes;
                    $scope.areas = data.areas;
                    $rootScope.loadingWork = false;
                    $('#customerDetail').modal('show');
                    return;
                    $scope.map = new google.maps.Map(document.getElementById('map-customer'), {
                        zoom: 15,
                        disableDefaultUI: true,
                        scrollwheel: false,
                        navigationControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        draggable: false,
                        center: new google.maps.LatLng(Number(data.customer.latitude), Number(data.customer.longitude)),
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    });
                    $scope.marker = new SlidingMarker({
                        position: new google.maps.LatLng(Number(data.customer.latitude), Number(data.customer.longitude)),
                        map: $scope.map,
                        visible: true,
                        draggable: true
                    });
                });
            }

            $scope.getLocationDetails = function (id) {
                $rootScope.loadingWork = true;
                Location.show(id).success(function (data, status, headers, config) {
                    $scope.location = data.location;
                    $rootScope.loadingWork = false;
                    $('#locationDetail').modal('show');
                });
            }

            $scope.getSupplierDetail = function (id) {
                $rootScope.loadingWork = true;
                Supplier.show(id).success(function (data, status, headers, config) {
                    $scope.customer = data.customer;
                    $scope.workTypes = data.workTypes;
                    $scope.areas = data.areas;
                    $rootScope.loadingWork = false;
                    $('#supplierDetail').modal('show');
                    return;
                });
            }

            $scope.getStockDetail = function (id) {
                $rootScope.loadingWork = true;
                Stock.get(id).success(function (data, status, headers, config) {
                    $scope.data = data;
                    $rootScope.loadingWork = false;
                    $('#stockDetail').modal('show');
                });
            }

            $scope.getDayendDetail = function (id) {
                $rootScope.loadingWork = true;
                Dayend.get(id).success(function (data, status, headers, config) {
                    $scope.data = data;
                    $rootScope.loadingWork = false;
                    $('#dayendDetail').modal('show');
                });
            }

            $scope.getStockStoreDetail = function (id) {
                $rootScope.loadingWork = true;
                StockStore.get(id).success(function (data, status, headers, config) {
                    $scope.data = data;
                    $rootScope.loadingWork = false;
                    $('#stockStoreDetail').modal('show');
                });
            }

            $scope.$on('$routeChangeStart', function (next, current) {
                $('.modal').modal('hide');
            });

            $scope.inputType = 'password';
            // Hide & show password function
            $scope.hideShowPassword = function () {
                if ($scope.inputType == 'password')
                    $scope.inputType = 'text';
                else
                    $scope.inputType = 'password';
            };
            $scope.inputTypeArr = [
                'password',
                'password',
                'password'
            ];
            $scope.hideShowPasswordArr = function (index) {
                if ($scope.inputTypeArr[index] == 'password')
                    $scope.inputTypeArr[index] = 'text';
                else
                    $scope.inputTypeArr[index] = 'password';
            };

            $scope.login = function (e) {
                User.login(e).success(function (data, status, headers, config) {
                    if (data.route == '/admin') {
                        location.reload();
                        return;
                    }
                    $scope.authenticatedUser = data.data;
                    AclService.flushStorage();
                    var abilities = {
                        user: []
                    };
                    AclService.setAbilities(abilities);
                    AclService.attachRole('user');
                    $scope.can = AclService.can;

                    socket.connect(data.stoken);

                    if (data.authorization.maps) AclService.addAbility('user', 'maps');
                    if (data.authorization.office) AclService.addAbility('user', 'office');
                    if (data.authorization.customers) AclService.addAbility('user', 'customers');
                    if (data.authorization.users) AclService.addAbility('user', 'users');
                    if (data.authorization.settings) AclService.addAbility('user', 'settings');
                    if (data.authorization.reports) AclService.addAbility('user', 'reports');
                    if (data.role == 3) AclService.addAbility('user', 'customer');

                    location.href = data.route;
                    return;
             

                }).error(function (data) {
                    var msg = (data && data.message) ? $translate.instant(data.message) : 'Giriş yapılamadı.';
                    Messenger().post({ message: msg, type: "error" });
                });
            };

            $scope.verificationRequired = false;
            $scope.canResend = false;
            $scope.remainingTime = 60;

            $scope.register = function (e) {
                User.register(e).success(function (data) {
                    if (data.requires_verification) {
                        $scope.verificationRequired = true;
                        $scope.startTimer();
                        Messenger().post(data.message);
                    } else {
                        $location.path('kayit-tamamlandi');
                    }
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $scope.startTimer = function () {
                $scope.remainingTime = 120;
                $scope.canResend = false;

                var timer = setInterval(function () {
                    $scope.remainingTime--;
                    if ($scope.remainingTime <= 0) {
                        clearInterval(timer);
                        $scope.canResend = true;
                    }
                    $scope.$apply();
                }, 1000);
            };

            $scope.resendCode = function () {
                if (!$scope.canResend) return;

                User.resendVerificationCode().success(function (data) {
                    $scope.startTimer();
                    Messenger().post(data.message);
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $scope.exportProof = function (status) {
                $scope.exportProofLoad = true;
                Order.exportProof($scope.selectedWork.id).success(function (data, status, headers, config) {
                    $scope.exportProofLoad = false;
                    window.location.href = data;
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                    $scope.exportProofLoad = false;
                });
            };

            $scope.forgot = function (e) {
                User.forgot({ email: e }).success(function (data, status, headers, config) {
                    Messenger().post("Mail Adresinize Sıfırlama Maili Gönderilmiştir.");
                    setTimeout(function () { window.location = "/"; }, 2000);
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $scope.filterWorkerFromTeam = function (item) {
                if ($scope.newOrderData.team_id !== null && typeof $scope.newOrderData.team_id !== 'undefined') {
                    return item.team_id === $scope.newOrderData.team_id;
                } else {
                    return item;
                }
            }

            $scope.password = function (e) {
                e.token = $routeParams.token;
                User.password(e).success(function (data, status, headers, config) {
                    Messenger().post(data.message);
                    $location.path('/login');
                }).error(function (data) {
                    Messenger().post({ message: data.message, type: "error" });
                });
            };

            $rootScope.$on('unauthorized', function () {
                $scope.logout();
            });

            $rootScope.closeModal = function (modal) {
                $('#accountLimit').modal('hide');
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');
            }

            $scope.logout = function () {
                // Clear all storage
                delete $localStorage.token;
                localStorage.clear();
                sessionStorage.clear();
                
                // Clear AngularJS scope
                $scope.authenticatedUser = null;
                $rootScope.authenticatedUser = null;
                
                // Redirect to logout
                window.location.href = '/cikis';
            };
            

            $scope.stringToArray = function (data) {
                return data.split(',');
            }

            $scope.toNumber = function (data) {
                return Number(data);
            }

            function clearMarker(type) {
                $scope.markers[type] = [];
            }

            $(document).on('click', '.dropdown-menu.dropdown-menu-form', function (e) {
                e.stopPropagation();
            });

            $scope.isActive = function (route) {
                var path = $location.url().split("/")[1];
                if (typeof route === 'string') {
                    return route == path;
                }
                return route.indexOf(path) !== -1;
            };

            $scope.isInclude = function (route) {
                if (Array.isArray(route)) {
                    var status = 0;
                    route.forEach(function (item) {
                        if ($location.url().indexOf(item) > -1) {
                            status += 1;
                        }
                    })
                    return status > 0 ? true : false;
                } else {
                    return $location.url().indexOf(route) > -1;
                }
            };


            $scope.isActiveCustomer = function (route) {
                var path = '';
                for (var index = 0; index < $location.url().split("/").length; index++) {
                    path += $location.url().split("/")[index] + '/';
                }
                return route.indexOf(path) !== -1;
            };

            $scope.isActiveStock = function (route) {
                var path = '';
                for (var index = 0; index < $location.url().split("/").length; index++) {
                    path += $location.url().split("/")[index] + '/';
                }
                return route.indexOf(path) > -1;
            };

            $scope.getDate = function (date) {
                return new Date(date);
            }

            $scope.print = function () {
                window.print();
            }

            function createMap() {
                var location = new google.maps.LatLng(Number($scope.authenticatedUser.location.lat), Number($scope.authenticatedUser.location.lon));

                setTimeout(function () {
                    $scope.searchMap = new google.maps.Map(document.getElementById('map-order'), {
                        zoom: 9,
                        center: location,
                        mapTypeId: google.maps.MapTypeId.ROADMAP
                    });

                    $scope.marker = new SlidingMarker({
                        position: location,
                        map: $scope.searchMap,
                        visible: true,
                        draggable: true
                    });

                    var input = document.getElementById('googlePlaceInput');
                    google.maps.event.addDomListener(input, 'keydown', function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        }
                    });

                    $scope.marker.addListener('dragend', function (event) {
                        var latlng = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
                        var geocoder = new google.maps.Geocoder();
                        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[0]) {
                                    var place = results[0];
                                    var details = place.geometry && place.geometry.location ? {
                                        latitude: place.geometry.location.lat(),
                                        longitude: place.geometry.location.lng()
                                    } : {};
                                    for (var i = 0; i < place.address_components.length; i++) {
                                        var addressType = place.address_components[i].types[0];
                                        if (componentForm[addressType]) {
                                            var val = place.address_components[i][componentForm[addressType]];
                                            details[mapping[addressType]] = val;
                                        }
                                    }
                                    details.formatted = place.formatted_address;
                                    details.placeId = place.place_id;
                                    details.address = place.formatted_address;
                                    angular.merge($scope.newOrderData.address, details);
                                    $scope.newOrderData.address.city = details.state;
                                    $scope.newOrderData.address.state = details.city;
                                    $scope.newOrderData.address.address = (details.number ? details.number : '') + ' ' + (details.street ? details.street : '');
                                    $scope.newOrderData.address.zipcode = details.zip;
                                    $rootScope.states.forEach(element => {
                                        if (element.abbreviation == details.city) {
                                            $scope.newOrderData.address.state = element.name;
                                            return true;
                                        }
                                    });
                                    $scope.$apply();
                                }
                            }
                        });
                    });
                }, 300);
            }

            var logo = $scope.logo = new FileUploader({
                url: '/api/upload-image-order',
                headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
                autoUpload: true
            });

            logo.filters.push({
                name: 'formatFilter',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    if ('|jpg|png|jpeg|bmp|gif|'.indexOf(type) === -1) {
                        alert('Sadece resim formatları desteklenmektedir. (jpg, png, jpeg, bmp, gif)');
                        return false;
                    };
                    return true;
                }
            });

            logo.onAfterAddingFile = function (fileItem) {
                $scope.progress = true;
                $scope.pending = true;
            };

            logo.onCompleteItem = function (item, response, status, headers) {
                $scope.progress = false;
                $scope.newOrderData.images.push(response.image);
                if (response.status == 'success') $scope.pending = false;
            }


            var document = $scope.document = new FileUploader({
                url: '/api/upload-document-worker',
                headers: { 'X-CSRF-TOKEN': CSRF_TOKEN },
                autoUpload: true
            });

            document.filters.push({
                name: 'formatFilter',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    if ('|jpg|png|jpeg|bmp|gif|pdf|doc|xlsx'.indexOf(type) === -1) {
                        alert('Sadece resim formatları desteklenmektedir. (jpg|png|jpeg|bmp|gif|pdf|doc|xlsx)');
                        return false;
                    };
                    return true;
                }
            });

            document.onAfterAddingFile = function (fileItem) {
                $scope.progress = true;
                $scope.pending = true;
            };

            document.onCompleteItem = function (item, response, status, headers) {
                $scope.progress = false;
                console.log(item)
                console.log(response)
                $scope.worker.company_document = response
            }

            $scope.deleteImgFromNewOrder = function (image) {
                var index = $scope.newOrderData.images.indexOf(image);
                $scope.newOrderData.images.splice(index, 1);
            }

            // import task list
            $scope.donwloadSampleExcel = function () {
                Order.donwloadSampleExcel().success(function (data, status, headers, config) {
                    downloadURI(data.url, "Lojimod Import Order.xlsx");
                });
            };

            function downloadURI(uri, name) {
                var link = document.createElement("a");
                link.download = name;
                link.href = uri;
                link.click();
            }

            $scope.importOrderList = function (files) {
                $scope.upload = true;
                var fd = new FormData();
                if ($rootScope.company_customer_id) {
                    fd.append('company_customer_id', $rootScope.company_customer_id);
                }
                var imgBlob = dataURItoBlob(files);
                fd.append('file', imgBlob);
                $http.post('/api/import-order-list', fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined,
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    }
                })
                    .success(function (response) {
                        // Messenger().post(response.message);
                        angular.element('#excelImportInput').val(null);
                        $('#importOrderList').modal('hide');
                        $rootScope.proccesCount = 2;
                        $('#successBox').modal('show');
                    })
                    .error(function (response) {
                        $rootScope.message = {
                            status: true,
                            type: 'error',
                            text: response.message
                        }
                        setTimeout(function () {
                            $rootScope.message.status = false;
                            $scope.$apply();
                        }, 3000);
                        // Messenger().post({message: response.message,type: "error"});
                    })
                    .finally(function (data) {
                        $scope.upload = false;
                    });
            };

            // FUPA Excel Import Function (for company_id 51)
            $scope.importFupaOrderList = function (files) {
                $scope.upload = true;
                var fd = new FormData();
                if ($rootScope.company_customer_id) {
                    fd.append('company_customer_id', $rootScope.company_customer_id);
                }
                var imgBlob = dataURItoBlob(files);
                fd.append('file', imgBlob);
                $http.post('/api/import-fupa-order-list', fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined,
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    }
                })
                    .success(function (response) {
                        angular.element('#fupaExcelImportInput').val(null);
                        $('#importFupaOrderList').modal('hide');
                        $rootScope.proccesCount = 2;
                        $rootScope.message = {
                            status: true,
                            type: 'success',
                            text: response.message || 'FUPA siparişleri başarıyla yüklendi!'
                        }
                        setTimeout(function () {
                            $rootScope.message.status = false;
                            $scope.$apply();
                        }, 3000);
                    })
                    .error(function (response) {
                        $rootScope.message = {
                            status: true,
                            type: 'error',
                            text: response.message || 'FUPA Excel yüklenirken hata oluştu!'
                        }
                        setTimeout(function () {
                            $rootScope.message.status = false;
                            $scope.$apply();
                        }, 3000);
                    })
                    .finally(function (data) {
                        $scope.upload = false;
                    });
            };

            $scope.uploadme;

            function dataURItoBlob(dataURI) {
                var binary = atob(dataURI.split(',')[1]);
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var array = [];
                for (var i = 0; i < binary.length; i++) {
                    array.push(binary.charCodeAt(i));
                }
                return new Blob([new Uint8Array(array)], {
                    type: mimeString
                });
            }

            $scope.humanizeDuration = function (time) {
                return humanizeDuration(time, { largest: 2, round: true, serialComma: false, language: $scope.mainLanguage });
            }

            $scope.sendComment = function (noteContent) {
                console.log(noteContent)
                if (typeof noteContent === 'undefined' || noteContent.length == 0) {
                    alert('Not girmediniz!');
                    return false;
                }
                $rootScope.loadingWork = true;
                var data = {
                    description: noteContent,
                    order_id: $rootScope.selectedWork.id
                }
                Order.sendComment(data).success(function (data, status, headers, config) {
                    $rootScope.loadingWork = false;
                    noteContent = '';
                    $rootScope.selectedWork.logs.unshift(data);
                    $('#noteInput').val('');
                    $scope.scrollEnd('msg_history');
                    $scope.noteContent = '';
                    delete noteContent;
                    setTimeout(() => {
                        $scope.$apply();
                    }, 300);
                });
                noteContent = null;
            }

            $scope.scrollEnd = function (id) {
                var div = document.getElementById(id);
                $('#' + id).animate({
                    scrollTop: div.scrollHeight - div.clientHeight
                }, 500);
            }

            $scope.sendSms = function (sms_content, to) {
                if (typeof sms_content === 'undefined' || sms_content.length == 0) {
                    alert('Boş sms gönderilemez!');
                    return false;
                }
                $rootScope.loadingWork = true;
                var data = {
                    sms_content: sms_content,
                    order_id: $rootScope.selectedWork.id,
                    to: to
                }
                Order.sendSms(data).success(function (data, status, headers, config) {
                    $rootScope.loadingWork = false;
                    $('#smsContent').val('');
                    $('#smsContent2').val('');
                    Messenger().post(data.message);
                });
            }

            $scope.sendCallRecord = function (reason, to) {
                if (typeof reason === 'undefined' || reason.length == 0) {
                    alert('Boş çağrı kaydı eklenemez!');
                    return false;
                }
                $rootScope.loadingWork = true;
                var data = {
                    reason: reason,
                    order_id: $rootScope.selectedWork.id,
                    to: to
                }
                Order.sendCallRecord(data).success(function (data, status, headers, config) {
                    $rootScope.loadingWork = false;
                    $('#callRecord').val('');
                    $scope.addCallRecord = false;
                    Messenger().post(data.message);
                });
            }

            $scope.sendCustomerNote = function (description, id) {
                if (typeof description === 'undefined' || description.length == 0) {
                    alert('Please fill note field!');
                    return false;
                }
                $rootScope.loadingWork = true;
                var data = {
                    description: description,
                    customer_id: id
                }
                Customer.sendNote(data).success(function (data, status, headers, config) {
                    $rootScope.loadingWork = false;
                    $scope.customer.notes.unshift(data);
                    $('#noteInputCustomer').val('');
                    description = '';
                });
            }

            $scope.toggleDays = function (item) {
                item.checked = !item.checked;
            }

            $scope.addReceiver = function () {
                if (typeof $scope.newOrderData.receivers === 'undefined') {
                    $scope.newOrderData.receivers = [{
                        'phone_number': ''
                    }];
                } else {
                    $scope.newOrderData.receivers.push({
                        'phone_number': ''
                    });
                }
            }

            $scope.removeReceiver = function (index) {
                $scope.newOrderData.receivers.splice(index, 1);
            }

            $scope.showImageDetails = function (index) {
                $scope.showImageDetail[index] = !$scope.showImageDetail[index];
            }

            $scope.toggleRepeat = function (bool) {
                if (!bool) {
                    delete $scope.newOrderData.repeat;
                } else {
                    $scope.newOrderData.repeat = {
                        period: 'day',
                        end: 0,
                        days: [
                            {
                                name: 'Pt',
                                value: 'Pt',
                                checked: true
                            },
                            {
                                name: 'Sa',
                                value: 'Sa',
                                checked: true
                            },
                            {
                                name: 'Ça',
                                value: 'Ça',
                                checked: true
                            },
                            {
                                name: 'Pe',
                                value: 'Pe',
                                checked: true
                            },
                            {
                                name: 'Cu',
                                value: 'Cu',
                                checked: true
                            },
                            {
                                name: 'Ct',
                                value: 'Ct',
                                checked: true
                            },
                            {
                                name: 'Pz',
                                value: 'Pz',
                                checked: true
                            }
                        ]
                    };
                }
            }

            $scope.goBack = function () {
                window.history.back();
            }

            $scope.intercom = function () {
                Intercom("boot", {
                    app_id: "ojb4g6vy"
                });
                Intercom('show');
            }

            $scope.finishTour = function () {
                Order.tour({ completed: true });
                $('#tutorialModal').modal('hide');
                $location.path('/map');
                $scope.authenticatedUser.tour = true;
                tourConfig.backDrop = true;
                var curStep = 0;
                if (typeof curStep === 'string')
                    curStep = parseInt(curStep);
                $scope.currentStep = curStep || 0;
                $('#tutorialModal').modal('hide');
                $scope.tour = 1;
                $scope.orderFromTour = false;
            }

            $scope.startCreateOrder = function () {
                $('#tutorialModal').modal('hide');
                $('#newOrder').modal('show');
                $scope.newTaskModal();
                $scope.orderFromTour = true;
            }

            $(window).on('shown.bs.modal', function () {
                // Tawk_API.hideWidget();
            });

            $(window).on('hidden.bs.modal', function () {
                // Tawk_API.showWidget();
            });


            $scope.refreshData = function (page) {
                $scope.$broadcast('refresh_data');
            }

            $scope.newData = function (page) {
                $scope.$broadcast('new_data');
            }

            $scope.editData = function (data) {
                $scope.$broadcast('edit_data', data);
            }

            $scope.callDriver = function (data) {
                $scope.$broadcast('call_driver', data);
            }

            $scope.openLightboxModal = function (index) {
                Lightbox.openModal($scope.selectedWork.images, index);
            };

            $scope.openImage = function (image) {
                var data = [
                    'https://s3.eu-central-1.amazonaws.com/herodispatcher/' + image
                ];
                console.log(data);
                Lightbox.openModal(data, 0);
            };

            $scope.filterProp = [];

            $scope.addFilterProps = function (item) {
                if ($scope.filterProp.indexOf(item) === -1)
                    $scope.filterProp.push(item);
                else {
                    var index = $scope.filterProp.indexOf(item);
                    $scope.filterProp.splice(index, 1);
                }
            }

            $scope.searchStock = function ($select, type) {
                if (type != lastType) $scope.searchRes = [];
                if ($select.search) {
                    return $http.get('api/find-stock', {
                        params: {
                            s: $select.search,
                            type: type
                        },
                        ignoreLoadingBar: true
                    }).then(function (response) {
                        $scope.searchRes = response.data.stocks;
                    });
                    lastType = type;
                };
            };

            $scope.removeFault = function (index) {
                $scope.newOrderData.faults.splice(index, 1);
            }

            $scope.addOrderFault = function () {
                if (typeof $scope.newOrderData.faults === 'undefined') {
                    $scope.newOrderData.faults = [];
                }
                $scope.newOrderData.faults.push({
                    stock_id: '',
                    description: ''
                });
            }

            $scope.removeChecklist = function (index) {
                $scope.newOrderData.checklists.splice(index, 1);
            }

            $scope.addChecklist = function () {
                if (typeof $scope.newOrderData.checklists === 'undefined') {
                    $scope.newOrderData.checklists = [];
                }
                $scope.newOrderData.checklists.push({
                    stock_id: '',
                    description: ''
                });
            }

            $scope.updateChecklist = function (item) {
                Order.updateChecklist(item).success(function (data, status, headers, config) {

                });
            }

            $scope.calculateChecklist = function (checklist) {
                var count = checklist.length,
                    completed = 0;
                checklist.forEach(element => {
                    if (element.status == 1 || element.status == 2) {
                        completed++
                    }
                });
                return Number((completed * 100) / count).toFixed(2);
            }

            $scope.copyToClipBoard = function (text) {
                navigator.clipboard.writeText(text).then(function () {
                    alert("Kopyalandı");
                }, function (err) {
                    console.error('Async: Could not copy text: ', err);
                });
            }

            $scope.completeDayend = function (dayend) {
                Dayend.completeDayend({ id: dayend.id }).success(function (data, status, headers, config) {
                    $scope.data.dayend.status = true;
                    $scope.$broadcast('completeDayend', dayend);
                });
            }

            $scope.unCompleteDayend = function (dayend) {
                Dayend.unCompleteDayend({ id: dayend.id }).success(function (data, status, headers, config) {
                    $scope.data.dayend.status = false;
                    $scope.$broadcast('unCompleteDayend', dayend);
                });
            }


            $scope.downloadExcelDayend = function () {
                var data = {
                    orders: []
                };
                $scope.data.dayend.orders.forEach(element => {
                    data.orders.push(element.id);
                });
                Order.generateExcelReport(data).success(function (data, status, headers, config) {
                    window.location.href = data['url'];
                    // setTimeout(function () {
                    //     Order.removeDownloadFile({ path: data['path'] }).success(function (response, status, headers, config) {
                    //         $scope.selectedItem = [];
                    //     });
                    // }, 2000)
                });
            };

            $scope.updateOrderField = function (key, value, order) {
                if (!value) {
                    alert('Boş değer girilemez!');
                    return;
                }
                var formParam = {
                    key: key,
                    value: value,
                    order_id: order.id,
                }
                Order.updateOrderField(formParam).success(function (data) {
                    if (key != 'company_id') {
                        $scope.getOrderDetails(order);
                    }
                    $scope.refreshData();
                });
            }

            $scope.resetRoute = function () {
                $location.search({});
            }

            $scope.getWorkerRoute = function (order) {
                if (order.route_optimization_id) {
                    window.open('/customer-routes?route_id=' + order.route_optimization_id, '_blank').focus();
                } else {
                    window.open('/customer-routes?route_id=' + order.worker.route_id, '_blank').focus();
                }
            }

            $scope.addTicket = function (order) {
                $location.path('/live-chat').search('order_id', order.id);

            }

            $scope.printCustomBarcode = function (selectedItems) {
                if (!selectedItems || selectedItems.length === 0) {
                    alert('Lütfen yazdırmak istediğiniz siparişleri seçiniz.');
                    return;
                }
                var orderIds = selectedItems;
                var orderIdString = orderIds.join(',');
                // Company 51 (Fupa): yeni 10x10 barkod sayfası; diğerleri: mevcut özelleştirilmiş barkod
                var url = ($scope.authenticatedUser && $scope.authenticatedUser.company_id == 51)
                    ? '/print-new-barcode/' + orderIdString
                    : '/print-custom-barcode/' + orderIdString;
                window.open(url, '_blank');
            }

            // FUPA (company 51): özel barkod sayfası - her zaman /print-custom-barcode/ kullanır
            $scope.openFupaCustomBarcode = function (selectedItems) {
                if (!selectedItems || selectedItems.length === 0) {
                    alert('Lütfen yazdırmak istediğiniz siparişleri seçiniz.');
                    return;
                }
                var orderIds = selectedItems;
                var orderIdString = orderIds.join(',');
                window.open('/print-custom-barcode/' + orderIdString, '_blank');
            }

        }

    ]);